import {Component, inject} from '@angular/core';
import {DialogRef} from '@angular/cdk/dialog';
import {CircleCheck, LucideAngularModule, X} from 'lucide-angular';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-contact-success',
  imports: [
    LucideAngularModule,
    TranslatePipe
  ],
  template: `
    <div class="bg-white p-6 md:p-8 rounded-xl w-dvw max-w-[85%] md:max-w-sm mx-auto">
      <div class="flex items-center justify-end">
        <button class="text-neutral-400 lg:hover:text-black" (click)="dialogRef.close()">
          <lucide-icon [img]="X" [size]="20" aria-hidden="true"/>
        </button>
      </div>
      <div class="flex flex-col items-center justify-center">
        <lucide-icon [img]="CircleCheck" [size]="50" class="text-green-500 mb-4" aria-hidden="true"/>
        <h3 class="text-2xl font-semibold mb-2.5">Success</h3>
        <p class="text-center text-neutral-700 mb-4">{{ 'CONTACT.FORM.SUCCESS' | translate }}</p>
        <button
          class="bg-green-600 lg:hover:bg-green-700 transition duration-200 text-white w-full py-2.5 rounded-md font-semibold"
          (click)="dialogRef.close()">
          OK
        </button>
      </div>
    </div>
  `,
  styles: ``
})
export class ContactSuccess {
  dialogRef = inject(DialogRef);
  protected readonly X = X;
  protected readonly CircleCheck = CircleCheck;
}
